import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1iz9uoy";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const iconWrapperCss = "i6cg1dp";
const iconPathCss = "ifjy3r7";
export const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
export const Icon = () => <svg width="100%" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d={'M4.84757 19.9319C4.84757 11.3341 11.8175 4.36417 20.4153 4.36417' + 'C29.0131 4.36417 35.9829 11.3341 35.9829 19.9319' + 'C35.9829 28.5297 29.0131 35.4995 20.4153 35.4995' + 'C11.8175 35.4995 4.84757 28.5297 4.84757 19.9319Z' + 'M20.4153 1.45508' + 'C10.2108 1.45508 1.93848 9.72742 1.93848 19.9319' + 'C1.93848 30.1363 10.2108 38.4086 20.4153 38.4086' + 'C24.6316 38.4086 28.5181 36.9964 31.6274 34.6191' + 'L44.4472 47.4388' + 'C45.0152 48.0068 45.9362 48.0068 46.5042 47.4388' + 'C47.0722 46.8707 47.0722 45.9498 46.5042 45.3817' + 'L33.796 32.6735' + 'C36.9536 29.3585 38.892 24.8715 38.892 19.9319' + 'C38.892 9.72742 30.6197 1.45508 20.4153 1.45508Z'} className={iconPathCss} />
    <path d={'M18.0281 20.7212' + 'C18.0281 21.6227 18.3372 22.3955 18.8781 22.9879' + 'L21.6857 22.1636' + 'C21.4281 21.9318 21.222 21.4939 21.222 21.0818' + 'C21.222 20.1288 22.0205 19.5621 22.922 18.8924' + 'C24.1584 18.0424 25.5235 17.0121 25.5235 14.8742' + 'C25.5235 12.4788 23.4887 10.8046 20.166 10.8046' + 'C17.9508 10.8046 15.8902 11.7061 14.5251 13.303' + 'L16.6114 15.647' + 'C17.4099 14.6939 18.4917 14.05 19.7796 14.05' + 'C21.1963 14.05 21.7887 14.7197 21.7887 15.5182' + 'C21.7887 16.2909 21.0932 16.7803 20.2948 17.347' + 'C19.2644 18.0939 18.0281 18.9439 18.0281 20.7212Z' + 'M18.0281 26.4394' + 'C18.0281 27.5727 18.9811 28.5258 20.1144 28.5258' + 'C21.2478 28.5258 22.2008 27.5727 22.2008 26.4394' + 'C22.2008 25.3061 21.2478 24.353 20.1144 24.353' + 'C18.9811 24.353 18.0281 25.3061 18.0281 26.4394Z'} className={iconPathCss} />
  </svg>;
export const ErrorState = () => <Container>
    <IconWrapper>
      <Icon />
    </IconWrapper>
    <strong>{I18n.t('publisher.organization.reporting.titles.load_error')}</strong>
    <span>{I18n.t('publisher.organization.reporting.errors.load_error')}</span>
  </Container>;

require("./error_state.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./error_state.js");